<template>
  <div id="app">
    <AppHeader class="app-header-global"/>
    <AppContent class="app-content-global"/>
    <AppFooter class="app-footer-global"/>
    <notifications classes="app-notification" group="google-maps-api-notifications" position="bottom center"></notifications>
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader";
import AppContent from "./components/AppContent";
import AppFooter from "./components/AppFooter";

export default {
  name: 'app',
  components: {
    AppFooter,
    AppContent,
    AppHeader
  },
  created(){
    // window.gm_authFailure = function() {
    //   this.$notify({
    //     group: 'google-maps-api-notifications',
    //     type: 'warn',
    //     title: 'Google-maps-api',
    //     closeOnClick: 'true',
    //     text: "fuck you dickhead",
    //   });
    // };
  },
  methods: {
    position(){
      return "center"
    }
  }
}
</script>

<style lang="scss">

  .app-notification{
    padding: 10px;
    margin: 0 5px 5px;
    font-size: 12px;
    color: #ffffff;
    background: rgb(8,81,156);
    text-align: center;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.3);

    .notification-title {
      letter-spacing: 1px;
      text-transform: uppercase;
      font-size: 10px;
    }

    &.info {
      color: #ffffff;
      background: rgb(8,81,156);
    }

    &.error {
      background: rgb(203,24,29);
    }
    &.warn {
      background: rgb(253,174,107);
      border: 1px solid rgb(253,141,60);
      /*background: rgb(253,141,60);*/
    }
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;

    display: flex;
    flex-direction: column;

    color: #2c3e50;
    font-size: 18px;
  }

  .app-header-global {
    flex: 0 1 auto;
  }

  .app-content-global {
    flex: 1;
  }

  .app-footer-global {
    flex: 0 1 auto;
  }

  body{
    margin: 0;
    padding: 0;
  }

  @media all and (min-width: 640px) {
    #app {
      height: 100vh;
    }
    .app-content-global {
      max-height: 85vh;
      min-width: 90vw;
    }

    .app-footer-global {

    }
  }
</style>
